/**
 * WorktimeTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const WorktimeTab = ({ ctx }) => {
  const {
    formData,
    handleWorkingTimeChange,
  } = ctx;

  return (
          <TabsContent value="worktime">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Briefcase className="w-5 h-5 text-stone-700" />
                  Planned Working Time (Infotype 0007)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Work Schedule Rule</Label>
                    <Input
                      value={formData.planned_working_time.work_schedule_rule}
                      onChange={(e) => handleWorkingTimeChange('work_schedule_rule', e.target.value)}
                      placeholder="STANDARD"
                    />
                  </div>
                  <div>
                    <Label>Time Management Status</Label>
                    <select
                      value={formData.planned_working_time.time_management_status}
                      onChange={(e) => handleWorkingTimeChange('time_management_status', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="0">No Time Management</option>
                      <option value="1">Positive Recording</option>
                      <option value="2">Negative Recording</option>
                    </select>
                  </div>
                  <div>
                    <Label>Daily Working Hours</Label>
                    <Input
                      value={formData.planned_working_time.daily_working_hours}
                      onChange={(e) => handleWorkingTimeChange('daily_working_hours', e.target.value)}
                      placeholder="09:00-18:00"
                    />
                  </div>
                  <div>
                    <Label>Working Hours/Week</Label>
                    <Input
                      type="number"
                      value={formData.planned_working_time.working_hours_per_week}
                      onChange={(e) => handleWorkingTimeChange('working_hours_per_week', parseFloat(e.target.value))}
                      min="0"
                      max="168"
                    />
                  </div>
                  <div>
                    <Label>Working Hours/Day</Label>
                    <Input
                      type="number"
                      value={formData.planned_working_time.working_hours_per_day}
                      onChange={(e) => handleWorkingTimeChange('working_hours_per_day', parseFloat(e.target.value))}
                      min="0"
                      max="24"
                    />
                  </div>
                  <div>
                    <Label>Working Days/Week</Label>
                    <Input
                      type="number"
                      value={formData.planned_working_time.working_days_per_week}
                      onChange={(e) => handleWorkingTimeChange('working_days_per_week', parseInt(e.target.value))}
                      min="1"
                      max="7"
                    />
                  </div>
                  <div>
                    <Label>Employment Percentage (%)</Label>
                    <Input
                      type="number"
                      value={formData.planned_working_time.employment_percent}
                      onChange={(e) => handleWorkingTimeChange('employment_percent', parseFloat(e.target.value))}
                      min="0"
                      max="100"
                    />
                  </div>
                  <div>
                    <Label>Part-Time Percentage (%)</Label>
                    <Input
                      type="number"
                      value={formData.planned_working_time.part_time_percentage}
                      onChange={(e) => handleWorkingTimeChange('part_time_percentage', parseFloat(e.target.value))}
                      min="0"
                      max="100"
                    />
                  </div>
                  <div>
                    <Label>Time Recording Variant</Label>
                    <Input
                      value={formData.planned_working_time.time_recording_variant}
                      onChange={(e) => handleWorkingTimeChange('time_recording_variant', e.target.value)}
                      placeholder="CLOCK"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default WorktimeTab;
